export default __webpack_public_path__ + "static/media/support-icon.62fb499e.png";